import {
  WagContentApiEndpoint,
  WAG_API_URL,
} from '../../constants';
import { BreedsQueryParams, BreedsResponse, BreedsResponseItem } from '../../types/api/breeds';
import { tryCatch } from '../../utils';
import { httpGet } from '../../wag-react/common/api';

export const getDogBreedAssetSuggestions = async (inputValue: string) => {
  const params: BreedsQueryParams = {
    nameSearchMethod: 'prefix',
    name: inputValue,
  };

  const [response, err] = await tryCatch(
    () => httpGet<BreedsResponse>(WagContentApiEndpoint.GetDogBreedAssets, {
      baseURL: WAG_API_URL,
      params,
    }));

  if (err) {
    return null;
  }
  const { items } = response.data;
  const validatedSuggestions = items.map(
    (suggestion: BreedsResponseItem) => ({
      value: suggestion.name,
      label: suggestion.name,
    }),
  );
  return validatedSuggestions;
};
